module.exports = __webpack_public_path__ + "static/media/17.cda67e62.png";